import NumericFormat from "react-number-format";
import RequestConfig from "../mini_components/RequestConfig";
import { toast } from "react-toastify";
import { convertToJalali } from "../mini_components/ConvertToJalali";
import { useQueryClient } from "@tanstack/react-query";

const NewWithdrawCard = ({ item, refetch }) => {
  const queryClient = useQueryClient();

  const handleCancelRequest = async (id) => {
    try {
      const method = item.internal ? "patch" : "delete";
      const url = item.internal
        ? `/internal_withdraws/${id}/`
        : `/withdraws/requests/${id}/`;
      const res = await RequestConfig({
        method: method,
        url: url,
      });
      //console.log(res.status === 204);
      if ([200,201,204].includes(res.status) ) {
        queryClient.invalidateQueries({ queryKey: ["getMoneyTransferReqs"] });
        queryClient.invalidateQueries({
          queryKey: ["getUserAvailabelBalance"],
        });
        toast.success("درخواست تسویه حذف گردید");
        refetch();
      }
    } catch (err) {
      //console.log(err);
    }
  };

  return (
    <div className="card-box-wrapper w-full  ">
      <div className="flex justify-between items-center w-full ">
        <div className="flex flex-col gap-1  text-dark  ">
          <p className="max-w-[200px] truncate text-[16px]  font-semibold">
            {item.internal ? item.recipient : item.destination_name}
          </p>
          <p className="truncate text-[14px]  text-neutral-50">
            {item.internal ? "داخلی" : item.destination_iban}
          </p>
        </div>
        <div className=" flex items-center font-bold text-[16px] gap-1">
          <NumericFormat
            value={Math.abs(item.amount)}
            displayType={"text"}
            thousandSeparator={true}
          />

          <span className="card-box-wrapper-date-text">ریال</span>
        </div>
      </div>

      <div className="flex justify-between items-end">
        <p className="card-box-wrapper-date-text " dir="ltr">
          {" "}
          {convertToJalali(item.updated_at)}
        </p>

        <button
          onClick={() => handleCancelRequest(item.id)}
          className="btn-exit "
        >
          <p>لغو درخواست</p>
        </button>
      </div>
    </div>
  );
};
export default NewWithdrawCard;
